import fuelSurchargesEditComponent from './fuel_surcharges.edit.component';

let fuelSurchargesEditModule = angular.module('fuelsurchargesedit', [
])

  .component('fuelsurchargesedit', fuelSurchargesEditComponent)

  .name;

export default fuelSurchargesEditModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/fuel_surcharges/edit/index.js